import Auth from './AuthService';
import MerchantService from './MerchantService';
import UserProfile from './UserProfileService';
import Web from './WebService';
import PlaidService from './PlaidService';
import UtilityService from './UtilityService';
import WalletService from './WalletService';
import UserService from './UserService';

export default {
    Auth: new Auth(),
    UserProfile: new UserProfile(),
    Web: new Web(),
    Merchants: new MerchantService(),
    Plaid: new PlaidService(),
    Utility: new UtilityService(),
    Wallet: new WalletService(),
    User: new UserService(),
};
